module.exports = __webpack_public_path__ + "img/101.8.b332be85.png";